import { FETCH_GROWTH_OPRTUNITY_ACC_CLEINT_FAILURE, FETCH_GROWTH_OPRTUNITY_ACC_CLEINT_REQUEST, FETCH_GROWTH_OPRTUNITY_ACC_CLEINT_SUCCESS } from "../actions/growthOpportunitiesByAccountAndClientActions";

  const initialState = {
    opportunities_data: [],
    opportunities_data_loading: false,
    opportunities_data_error: null,
  };
  
  const growthOpportunitiesByAccountAndClientReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_GROWTH_OPRTUNITY_ACC_CLEINT_REQUEST:
        return { ...state, opportunities_data_loading: true , payload: action.payload};
      case FETCH_GROWTH_OPRTUNITY_ACC_CLEINT_SUCCESS:
        return { ...state, opportunities_data_loading: false, opportunities_data: action.payload };
      case FETCH_GROWTH_OPRTUNITY_ACC_CLEINT_FAILURE:
        return { ...state, opportunities_data_loading: false, opportunities_data_error: action.payload };
      default:
        return state;
    }
  };
  
  export default growthOpportunitiesByAccountAndClientReducer;
  